import { render, staticRenderFns } from "./ManageJobfairJobs.vue?vue&type=template&id=fc3c8cb0"
import script from "./ManageJobfairJobs.vue?vue&type=script&lang=js"
export * from "./ManageJobfairJobs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports